<template>
    <div style="text-align: center">
        <a target="_blank" title="The app on Google Play"
           href="https://play.google.com/store/apps/details?id=com.pazukdev.oldvehicles">
            <img style="width: 240px" alt="The app on Google Play"
                 src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png">
        </a>
    </div>
</template>

<script>
    export default {
        name: "GooglePlayLink"
    }
</script>

<style scoped>

</style>